import energy01 from './energy/energy_01.png';
import energy02 from './energy/energy_02.png';
import energy03 from './energy/energy_03.png';
import energy04 from './energy/energy_04.png';
import energy05 from './energy/energy_05.png';
import energy06 from './energy/energy_06.png';
import energy07 from './energy/energy_07.png';
import energy08 from './energy/energy_08.png';
import energy09 from './energy/energy_09.png';
import energy10 from './energy/energy_10.png';
import energy11 from './energy/energy_11.png';
import gas01 from './gas/gas_01.png';
import gas02 from './gas/gas_02.png';
import gas03 from './gas/gas_03.png';
import gas04 from './gas/gas_04.png';
import gas05 from './gas/gas_05.png';
import gas06 from './gas/gas_06.png';
import gas07 from './gas/gas_07.png';
import gas08 from './gas/gas_08.png';
import gas09 from './gas/gas_09.png';
import gas10 from './gas/gas_10.png';
import gas11 from './gas/gas_11.png';
import gas12 from './gas/gas_12.png';
import gas13 from './gas/gas_13.png';
import gas14 from './gas/gas_14.png';
import production101 from './production1/production1_01.png';
import production102 from './production1/production1_02.png';
import production103 from './production1/production1_03.png';
import production104 from './production1/production1_04.png';
import production105 from './production1/production1_05.png';
import production106 from './production1/production1_06.png';
import production107 from './production1/production1_07.png';
import production108 from './production1/production1_08.png';
import production109 from './production1/production1_09.png';
import production110 from './production1/production1_10.png';
import production111 from './production1/production1_11.png';
import production112 from './production1/production1_12.png';
import production113 from './production1/production1_13.png';
import production114 from './production1/production1_14.png';
import production115 from './production1/production1_15.png';
import production116 from './production1/production1_16.png';
import production117 from './production1/production1_17.png';
import production118 from './production1/production1_18.png';
import production119 from './production1/production1_19.png';
import production120 from './production1/production1_20.png';
import production121 from './production1/production1_21.png';
import production122 from './production1/production1_22.png';
import production123 from './production1/production1_23.png';
import production124 from './production1/production1_24.png';
import production125 from './production1/production1_25.png';
import production126 from './production1/production1_26.png';
import production127 from './production1/production1_27.png';
import production128 from './production1/production1_28.png';
import production129 from './production1/production1_29.png';
import production130 from './production1/production1_30.png';
import production131 from './production1/production1_31.png';
import production201 from './production2/production2_01.png';
import production202 from './production2/production2_02.png';
import production203 from './production2/production2_03.png';
import production204 from './production2/production2_04.png';
import production205 from './production2/production2_05.png';
import production206 from './production2/production2_06.png';
import production207 from './production2/production2_07.png';
import production208 from './production2/production2_08.png';
import production209 from './production2/production2_09.png';
import production210 from './production2/production2_10.png';
import production211 from './production2/production2_11.png';
import production212 from './production2/production2_12.png';
import production213 from './production2/production2_13.png';
import production214 from './production2/production2_14.png';
import production215 from './production2/production2_15.png';
import production216 from './production2/production2_16.png';
import production217 from './production2/production2_17.png';
import production218 from './production2/production2_18.png';
import production219 from './production2/production2_19.png';
import production220 from './production2/production2_20.png';
import production221 from './production2/production2_21.png';
import production222 from './production2/production2_22.png';
import production223 from './production2/production2_23.png';
import production224 from './production2/production2_24.png';
import production225 from './production2/production2_25.png';
import production226 from './production2/production2_26.png';
import production227 from './production2/production2_27.png';
import production228 from './production2/production2_28.png';
import production229 from './production2/production2_29.png';
import production230 from './production2/production2_30.png';
import production231 from './production2/production2_31.png';
import production232 from './production2/production2_32.png';
import production233 from './production2/production2_33.png';
import production234 from './production2/production2_34.png';
import roads01 from './roads/roads_01.png';
import roads02 from './roads/roads_02.png';
import roads03 from './roads/roads_03.png';
import roads04 from './roads/roads_04.png';
import roads05 from './roads/roads_05.png';
import roads06 from './roads/roads_06.png';
import transport01 from './transport/transport_01.png';
import transport02 from './transport/transport_02.png';
import transport03 from './transport/transport_03.png';
import transport04 from './transport/transport_04.png';
import transport05 from './transport/transport_05.png';
import transport06 from './transport/transport_06.png';
import transport07 from './transport/transport_07.png';
import transport08 from './transport/transport_08.png';
import transport09 from './transport/transport_09.png';
import transport10 from './transport/transport_10.png';
import transport11 from './transport/transport_11.png';
import transport12 from './transport/transport_12.png';
import transport13 from './transport/transport_13.png';
import transport14 from './transport/transport_14.png';
import transport15 from './transport/transport_15.png';
import transport16 from './transport/transport_16.png';
import transport17 from './transport/transport_17.png';
import transport18 from './transport/transport_18.png';
import transport19 from './transport/transport_19.png';
import transport20 from './transport/transport_20.png';
import transport21 from './transport/transport_21.png';
import transport22 from './transport/transport_22.png';
import transport23 from './transport/transport_23.png';
import transport24 from './transport/transport_24.png';
import transport25 from './transport/transport_25.png';
import transport26 from './transport/transport_26.png';
import transport27 from './transport/transport_27.png';
import transport28 from './transport/transport_28.png';
import transport29 from './transport/transport_29.png';
import transport30 from './transport/transport_30.png';
import transport31 from './transport/transport_31.png';
import transport32 from './transport/transport_32.png';
import transport33 from './transport/transport_33.png';
import transport34 from './transport/transport_34.png';

export interface IConstructionTypeIcon {
    code: string;
    src: string;
}

export interface IConstructionTypeIconGroup {
    key: string;
    label: string;
    icons: IConstructionTypeIcon[];
}

export const CONSTRUCTION_TYPE_ICON_GROUPS: IConstructionTypeIconGroup[] = [
    {
        key: 'production1',
        label: 'Добыча 1/2',
        icons: [
            { code: 'production1_01', src: production101 },
            { code: 'production1_02', src: production102 },
            { code: 'production1_03', src: production103 },
            { code: 'production1_04', src: production104 },
            { code: 'production1_05', src: production105 },
            { code: 'production1_06', src: production106 },
            { code: 'production1_07', src: production107 },
            { code: 'production1_08', src: production108 },
            { code: 'production1_09', src: production109 },
            { code: 'production1_10', src: production110 },
            { code: 'production1_11', src: production111 },
            { code: 'production1_12', src: production112 },
            { code: 'production1_13', src: production113 },
            { code: 'production1_14', src: production114 },
            { code: 'production1_15', src: production115 },
            { code: 'production1_16', src: production116 },
            { code: 'production1_17', src: production117 },
            { code: 'production1_18', src: production118 },
            { code: 'production1_19', src: production119 },
            { code: 'production1_20', src: production120 },
            { code: 'production1_21', src: production121 },
            { code: 'production1_22', src: production122 },
            { code: 'production1_23', src: production123 },
            { code: 'production1_24', src: production124 },
            { code: 'production1_25', src: production125 },
            { code: 'production1_26', src: production126 },
            { code: 'production1_27', src: production127 },
            { code: 'production1_28', src: production128 },
            { code: 'production1_29', src: production129 },
            { code: 'production1_30', src: production130 },
            { code: 'production1_31', src: production131 },
        ],
    },
    {
        key: 'production2',
        label: 'Добыча 2/2',
        icons: [
            { code: 'production2_01', src: production201 },
            { code: 'production2_02', src: production202 },
            { code: 'production2_03', src: production203 },
            { code: 'production2_04', src: production204 },
            { code: 'production2_05', src: production205 },
            { code: 'production2_06', src: production206 },
            { code: 'production2_07', src: production207 },
            { code: 'production2_08', src: production208 },
            { code: 'production2_09', src: production209 },
            { code: 'production2_10', src: production210 },
            { code: 'production2_11', src: production211 },
            { code: 'production2_12', src: production212 },
            { code: 'production2_13', src: production213 },
            { code: 'production2_14', src: production214 },
            { code: 'production2_15', src: production215 },
            { code: 'production2_16', src: production216 },
            { code: 'production2_17', src: production217 },
            { code: 'production2_18', src: production218 },
            { code: 'production2_19', src: production219 },
            { code: 'production2_20', src: production220 },
            { code: 'production2_21', src: production221 },
            { code: 'production2_22', src: production222 },
            { code: 'production2_23', src: production223 },
            { code: 'production2_24', src: production224 },
            { code: 'production2_25', src: production225 },
            { code: 'production2_26', src: production226 },
            { code: 'production2_27', src: production227 },
            { code: 'production2_28', src: production228 },
            { code: 'production2_29', src: production229 },
            { code: 'production2_30', src: production230 },
            { code: 'production2_31', src: production231 },
            { code: 'production2_32', src: production232 },
            { code: 'production2_33', src: production233 },
            { code: 'production2_34', src: production234 },
        ],
    },
    {
        key: 'gas',
        label: 'Газ',
        icons: [
            { code: 'gas_01', src: gas01 },
            { code: 'gas_02', src: gas02 },
            { code: 'gas_03', src: gas03 },
            { code: 'gas_04', src: gas04 },
            { code: 'gas_05', src: gas05 },
            { code: 'gas_06', src: gas06 },
            { code: 'gas_07', src: gas07 },
            { code: 'gas_08', src: gas08 },
            { code: 'gas_09', src: gas09 },
            { code: 'gas_10', src: gas10 },
            { code: 'gas_11', src: gas11 },
            { code: 'gas_12', src: gas12 },
            { code: 'gas_13', src: gas13 },
            { code: 'gas_14', src: gas14 },
        ],
    },
    {
        key: 'energy',
        label: 'Энергетика',
        icons: [
            { code: 'energy_01', src: energy01 },
            { code: 'energy_02', src: energy02 },
            { code: 'energy_03', src: energy03 },
            { code: 'energy_04', src: energy04 },
            { code: 'energy_05', src: energy05 },
            { code: 'energy_06', src: energy06 },
            { code: 'energy_07', src: energy07 },
            { code: 'energy_08', src: energy08 },
            { code: 'energy_09', src: energy09 },
            { code: 'energy_10', src: energy10 },
            { code: 'energy_11', src: energy11 },
        ],
    },
    {
        key: 'transport',
        label: 'Транспорт',
        icons: [
            { code: 'transport_01', src: transport01 },
            { code: 'transport_02', src: transport02 },
            { code: 'transport_03', src: transport03 },
            { code: 'transport_04', src: transport04 },
            { code: 'transport_05', src: transport05 },
            { code: 'transport_06', src: transport06 },
            { code: 'transport_07', src: transport07 },
            { code: 'transport_08', src: transport08 },
            { code: 'transport_09', src: transport09 },
            { code: 'transport_10', src: transport10 },
            { code: 'transport_11', src: transport11 },
            { code: 'transport_12', src: transport12 },
            { code: 'transport_13', src: transport13 },
            { code: 'transport_14', src: transport14 },
            { code: 'transport_15', src: transport15 },
            { code: 'transport_16', src: transport16 },
            { code: 'transport_17', src: transport17 },
            { code: 'transport_18', src: transport18 },
            { code: 'transport_19', src: transport19 },
            { code: 'transport_20', src: transport20 },
            { code: 'transport_21', src: transport21 },
            { code: 'transport_22', src: transport22 },
            { code: 'transport_23', src: transport23 },
            { code: 'transport_24', src: transport24 },
            { code: 'transport_25', src: transport25 },
            { code: 'transport_26', src: transport26 },
            { code: 'transport_27', src: transport27 },
            { code: 'transport_28', src: transport28 },
            { code: 'transport_29', src: transport29 },
            { code: 'transport_30', src: transport30 },
            { code: 'transport_31', src: transport31 },
            { code: 'transport_32', src: transport32 },
            { code: 'transport_33', src: transport33 },
            { code: 'transport_34', src: transport34 },
        ],
    },
    {
        key: 'roads',
        label: 'Дороги',
        icons: [
            { code: 'roads_01', src: roads01 },
            { code: 'roads_02', src: roads02 },
            { code: 'roads_03', src: roads03 },
            { code: 'roads_04', src: roads04 },
            { code: 'roads_05', src: roads05 },
            { code: 'roads_06', src: roads06 },
        ],
    },
];

export const CONSTRUCTION_TYPE_ICONS: Record<string, string> = Object.fromEntries(
    CONSTRUCTION_TYPE_ICON_GROUPS.flatMap(({ icons }) => icons.map(({ code, src }) => [code, src])),
);
